{
  "page": {
    "title": "Transfers",
    "subtitle": "Negotiate directly with other managers",
    "subtitleWithBalance": "Negotiate directly with other managers · Balance {balance} CZ$",
    "balance": "Balance",
    "loadingAria": "Loading transfers"
  },
  "tabs": {
    "received": "Received offers",
    "sent": "Sent offers",
    "archive": "History ({count})",
    "market": "Market ({count})",
    "trades": "All trades"
  },
  "modes": {
    "handle": "To handle",
    "negotiations": "Negotiations",
    "market": "Market",
    "trades": "All trades"
  },
  "tradeList": {
    "tableLabel": "Every rider move in the game, newest first",
    "loadingAria": "Loading trades",
    "loadError": "I could not load the trade list.",
    "errorTitle": "The trade list did not load",
    "errorBody": "Nothing is lost. Try again in a moment.",
    "retry": "Try again",
    "count": "{count, plural, one {# trade shown} other {# trades shown}}",
    "loadMore": "Show more",
    "loadingMore": "Loading",
    "depthCapNote": "This is as far back as the list goes. Use the filters to find older moves.",
    "emptyTitle": "Sign your first rider",
    "emptyBody": "No rider has changed hands yet. The market is where the first ones will.",
    "emptyAction": "Browse the market",
    "emptyFilteredTitle": "Widen the search",
    "emptyFilteredBody": "No moves match these filters.",
    "reportAria": "Report this trade for review",
    "freeAgent": "Free agent",
    "header": {
      "rider": "Rider",
      "type": "Type",
      "date": "Date",
      "from": "From",
      "to": "To",
      "amount": "Fee"
    },
    "filter": {
      "typeLabel": "Filter by type",
      "typeAll": "All types",
      "divisionLabel": "Filter by division",
      "divisionAll": "All divisions",
      "divisionOption": "Division {n}",
      "mineOnly": "My team only",
      "reset": "Clear filters"
    }
  },
  "status": {
    "pending": "Awaiting response",
    "countered": "Counter sent",
    "awaitingConfirmation": "Awaiting confirmation",
    "accepted": "Accepted",
    "rejected": "Rejected",
    "withdrawn": "Withdrawn"
  },
  "type": {
    "auction": "Auction",
    "transfer": "Transfer",
    "swap": "Swap",
    "academy": "Academy"
  },
  "direction": {
    "in": "Buy",
    "out": "Sell",
    "swap": "Swap",
    "noSale": "No sale"
  },
  "relativeTime": {
    "justNow": "Just now",
    "minutes": "{m}m ago",
    "hours": "{h}h ago",
    "days": "{day}d ago",
    "dash": "—"
  },
  "offerCard": {
    "from": "From",
    "to": "To",
    "round": "Round {round}",
    "squadCriticalReceived": "🚨 Below minimum",
    "squadCriticalSent": "🚨 Seller below min.",
    "offerLabel": "Offer",
    "counterLabel": "Your counter",
    "counterAmountLabel": "Counter offer",
    "yourBidLabel": "Your bid",
    "value": "Value",
    "salary": "Salary",
    "estSalary": "Est. salary",
    "contractExpires": "Exp. after season {season}",
    "noContract": "Free agent",
    "buttons": {
      "accept": "✓ Accept",
      "counter": "Counter",
      "reject": "✕ Reject",
      "send": "Send",
      "acceptCounter": "✓ Accept ({amount} CZ$)",
      "newOffer": "New offer",
      "withdraw": "Withdraw",
      "withdrawOffer": "Withdraw offer",
      "withdrawCounter": "Withdraw counter offer",
      "confirmDeal": "✓ Confirm deal ({amount} CZ$)",
      "cancelDeal": "Cancel deal",
      "archive": "Archive"
    },
    "form": {
      "counterLabel": "Your counter (CZ$)",
      "newOfferLabel": "New offer (CZ$)",
      "messageBuyer": "Optional message to buyer...",
      "messagePlaceholder": "Optional message...",
      "offerAmountBlocked": "Enter an offer above 0 CZ$"
    },
    "awaiting": {
      "sellerAccepted": "You accepted · awaiting buyer's confirmation",
      "buyerConfirmed": "You confirmed · awaiting seller's confirmation"
    }
  },
  "swapCard": {
    "youOffer": "You offer",
    "theyOffer": "They offer",
    "youWant": "You want",
    "theyWant": "They want",
    "pureSwap": "Pure swap",
    "cashFrom": "+{amount} CZ$ from {team}",
    "counterTag": "(counter)",
    "buttons": {
      "accept": "✓ Accept",
      "counter": "Counter",
      "reject": "✕ Reject",
      "acceptCounter": "✓ Accept counter",
      "send": "Send",
      "withdraw": "Withdraw proposal",
      "rejectShort": "Reject",
      "confirmSwap": "✓ Confirm swap",
      "cancelSwap": "Cancel deal",
      "archive": "Archive"
    },
    "form": {
      "cashReceiveLabel": "Cash payment (CZ$) · positive = you receive, negative = you pay",
      "cashPayLabel": "Cash payment (CZ$) · positive = you pay, negative = you receive"
    },
    "awaiting": {
      "selfConfirmed": "You confirmed · awaiting the other party"
    }
  },
  "transferCard": {
    "send": "Send",
    "messagePlaceholder": "Message (optional)...",
    "removeListing": "Remove from transfer list",
    "removing": "Removing...",
    "removeAria": "Remove {riderName} from transfer list",
    "removeConfirm": "Remove {riderName} from transfer list?",
    "ridersForSale": "rider",
    "editPrice": "Edit price",
    "editPriceAria": "Edit asking price for {riderName}",
    "editPriceLabel": "New asking price (CZ$)",
    "savePrice": "Save",
    "priceInvalid": "Enter a whole number above 0 CZ$",
    "cancel": "Cancel",
    "confirmRemoveButton": "Yes, remove"
  },
  "history": {
    "title": "Transfer history",
    "seasonFilterAll": "All seasons",
    "seasonFilterCurrent": "Season {n} (this)",
    "seasonOption": "Season {n}",
    "emptyAll": "The team has no transfer history yet.",
    "emptyFiltered": "No transfers found for the selected season.",
    "header": {
      "date": "Date",
      "type": "Type",
      "direction": "Direction",
      "rider": "Rider",
      "counterparty": "Counterparty",
      "amount": "Amount"
    },
    "aiTag": "(AI)",
    "swapZero": "0 CZ$",
    "noBids": "No bids",
    "academySource": "Academy",
    "aiTeamFallback": "AI team",
    "loadError": "Could not load transfer history",
    "noSaleToggle": "Show auctions with no bids",
    "noSaleHiddenNote": "{count, plural, one {# auction with no bids is} other {# auctions with no bids are}} hidden. No rider changed hands.",
    "showMore": "Show more ({shown} of {total})",
    "emptyFilteredNoSaleOnly": "No actual transfers in the selected season: only auctions with no bids (hidden, see filter above).",
    "reportAction": "Report for review",
    "reportActionAria": "Report this trade for review"
  },
  "report": {
    "title": "Report this trade",
    "subtitle": "Send it to me for a closer look. This isn't an accusation, just a flag for me to check.",
    "messageLabel": "What looked off?",
    "messagePlaceholder": "Describe what stood out to you...",
    "messageHelper": "{count} characters left",
    "cancel": "Cancel",
    "confirm": "Send report",
    "close": "Close",
    "closeAction": "Close",
    "done": "Thanks. I'll take a look.",
    "alreadyDone": "Your team already reported this trade. I've got it.",
    "error": "Could not send the report. Try again in a moment.",
    "rateLimited": "You've sent a few reports already. Try again in a bit.",
    "tooShort": "Say a bit more: at least {min} characters.",
    "tooLong": "Keep it under {max} characters."
  },
  "profit": {
    "title": "Transfer profit per rider",
    "subtitle": "All seasons. Sale price vs. purchase price for riders the team has sold.",
    "header": {
      "rider": "Rider",
      "bought": "Bought",
      "sold": "Sold",
      "profit": "Profit/loss"
    },
    "unknownBuy": "Unknown",
    "unknownBuyHint": "No purchase found in the team's history, e.g. initial squad or swap. Profit cannot be calculated.",
    "unknownAcademyBuy": "Academy (cost unknown)",
    "unknownAcademyBuyHint": "This rider was signed from the academy before cost tracking was added. Profit cannot be calculated.",
    "total": "Total realized profit",
    "totalExcluded": "{count, plural, one {# sale} other {# sales}} without a known purchase price, not included in the total."
  },
  "sections": {
    "archivedReceived": "Archived received offers",
    "archivedSent": "Archived sent offers",
    "receivedProposals": "Received proposals",
    "sentProposals": "Sent proposals",
    "archivedReceivedProposals": "Archived received proposals",
    "archivedSentProposals": "Archived sent proposals"
  },
  "empty": {
    "received": "Browse the market while you wait",
    "receivedHint": "Other managers send offers on your riders from the rider's page.",
    "sent": "Send your first offer",
    "sentHint": "Open a rider's page and click \"Send transfer offer\".",
    "archive": "Check your open negotiations",
    "archiveHint": "Deals you close or reject land here.",
    "marketNoListings": "List a rider for sale",
    "marketNoListingsHint": "Nothing is on the transfer list right now. Set an asking price from your squad.",
    "marketNoMatches": "Widen your filter",
    "marketNoMatchesHint": "No rider on the list matches the current filter.",
    "ctaBrowseMarket": "Open the market",
    "ctaSeeSent": "See sent offers",
    "ctaListRider": "Open my squad"
  },
  "toast": {
    "offerSent": "✅ Offer sent!",
    "listingRemoved": "✅ Rider removed from transfer list",
    "listingRemoveFailed": "Could not remove listing",
    "offerAcceptedBuyer": "✅ Accepted · buyer must now confirm the deal",
    "offerAcceptedSeller": "✅ Accepted · seller must now confirm the deal",
    "confirmedAwaiting": "✅ Confirmed · awaiting the other party's confirmation",
    "dealCancelled": "Deal cancelled",
    "transferRejected": "Transfer rejected",
    "counterSent": "Counter sent",
    "counterWithdrawn": "Counter offer withdrawn",
    "newOfferSent": "New offer sent",
    "offerWithdrawn": "Offer withdrawn",
    "offerArchived": "Offer archived",
    "updated": "✅ Updated",
    "swapAccepted": "✅ Accepted · awaiting confirmation",
    "swapConfirmedAwaiting": "✅ Confirmed · awaiting the other party",
    "swapCancelled": "Swap cancelled",
    "swapRejected": "Swap rejected",
    "proposalWithdrawn": "Proposal withdrawn",
    "swapArchived": "Proposal archived",
    "priceUpdated": "✅ Asking price updated",
    "priceUpdateFailed": "Could not update the price"
  },
  "celebration": {
    "transferDone": {
      "title": "Transfer complete! 🎉",
      "subtitle": "The rider is now on your team"
    },
    "swapDone": {
      "title": "Swap complete! 🎉",
      "subtitle": "Riders have been exchanged"
    },
    "buyoutDone": {
      "title": "Rider bought! 🎉",
      "subtitle": "The buy option has been exercised"
    }
  },
  "marketSort": {
    "label": "Sort by",
    "ascAria": "Sort ascending",
    "descAria": "Sort descending"
  },
  "marketRow": {
    "nation": "Nation",
    "rider": "Rider",
    "seller": "Seller",
    "age": "Age",
    "listed": "Listed",
    "value": "Value",
    "salary": "Salary",
    "price": "Asking price",
    "action": "Action",
    "offer": "Send offer",
    "manage": "Manage",
    "close": "Close",
    "offerAria": "Send offer on {riderName}",
    "manageAria": "Manage listing for {riderName}",
    "selectAria": "Select {riderName} for bulk price edit",
    "countLine": "Showing {shown} of {total} listings"
  },
  "bulkPrice": {
    "selected": "{count} selected",
    "selectAllVisible": "Select all listed riders ({count})",
    "clear": "Clear selection",
    "mode": {
      "percent": "Percent",
      "amount": "Amount CZ$",
      "set": "Set price"
    },
    "valueLabel": "Value",
    "valuePlaceholder": {
      "percent": "e.g. 10 for +10%, -10 for -10%",
      "amount": "e.g. 500 or -500",
      "set": "New asking price"
    },
    "previewTitle": "Preview",
    "previewEmpty": "Enter a value to preview the new prices.",
    "previewMore": "+ {count} more",
    "apply": "Apply to {count} riders",
    "applying": "Applying...",
    "toastSuccess": "Updated {count} prices",
    "toastPartial": "Updated {updated}, {failed} could not be updated",
    "toastNoChange": "No price change to apply",
    "toastFailed": "Could not update prices"
  },
  "valueDelta": {
    "under": "{pct}% below est. value",
    "over": "{pct}% above est. value",
    "at": "Near est. value",
    "title": "Estimated market value: {amount} CZ$. A model estimate, not a guaranteed price."
  }
}
